<template>
	<div class='antidisease-wrap'>
		<!-- <el-image style="width: 100%; height: 120px" src="../static/images/index/fy.png" fit="fit"></el-image> -->
		<img style="width: 100%; height: 120px" src="../static/images/index/fy.png" alt="">
		<div class="flex flex-row-between flex-items-start antidisease-box">
			<!-- <div class="left-wrap">
				<div class="flex flex-row-between">
					<div class="antidisease-nav">
						<i class="el-icon-s-goods"></i>
						防疫红榜
					</div>
					<router-link tag="a" to="/antiDiseaseList?type=防疫红榜">更多</router-link>
				</div>
				<ul class="">
					<li class="">
						<router-link class="antidisease--list" to="" tag="a" target="_blank">
							<div class="flex">
								<span class="title ellipsis-1">事关健康通行码！督导（暗访）检查情况通报！肥城疫情处置工作领...</span>
								<span class="source ellipsis-1">肥城市新城街道办事处</span>
								<span class="time">05-15</span>
							</div>
							<div class="content">督导（暗访）检查情况通报&nbsp;按照肥城市委新冠肺炎疫情处置领导小组（指挥部）安排，5月14日，督导（暗访）检查组对各镇街区健康通行码办理情况进行了暗访检查。共检查4...</div>
						</router-link>
					</li>
				</ul>
			</div> -->
			<div v-for="(item, index) in tabList" :key="index" :class="[index===0?'left-wrap':'right-wrap']">
				<div class="flex flex-row-between">
					<div class="antidisease-nav">
						<i class="el-icon-s-goods"></i>
						{{item.fullName}}
					</div>
					<router-link tag="a" :to="`/antiDiseaseList?type=${item.fullName}&category=${item.id}`">更多</router-link>
				</div>
				<ul class="">
					<li class="" v-for="(list, listIndex) in index===0?list1:list2" :key="listIndex">
						<router-link class="antidisease--list" :to="`/common/article/0/${item.id}`" tag="a" target="_blank">
							<div class="flex">
								<span class="title ellipsis-1">{{list.title}}</span>
								<span class="source ellipsis-1">{{list.source}}</span>
								<span class="time">{{list.publishtime}}</span>
							</div>
							<div class="content">{{list.description}}</div>
						</router-link>
					</li>
				</ul>
				<!-- <empty v-if="item.tableList.length === 0" /> -->
			</div>
		</div>
	</div>
</template>

<script>
import empty from '@/components/empty';
import { dictionaryTypes, articleTopics } from '@/api';
export default {
	components: { empty },
	data() {
		return {
			tabList: [],
			list1: [],
			list2: [],
		}
	},
	created() { },
	mounted() {
		this.getList();
	},
	methods: {
		getCode() {
			let tabList = dictionaryTypes({ code: 'topic', category: 'COVID-19' });
			return tabList;
		},

		async getTabList(code) {
			if (this.tabList.length === 0) {
				const tabList = await this.getCode();
				const [first] = tabList;
				this.$set(this, 'tabList', first.chlids || []);
			}
		},

		async getList(page = 1) {
			await this.getTabList();
			this.tabList.map((item, index) => {
				articleTopics({ category: item.id, current: 1 }).then(res => {
					if (index === 0) {
						this.$set(this, 'list1', res.records || []);
					} else {
						this.$set(this, 'list2', res.records || []);
					}
				})
			})
		},

		getTableList(id) {
			const tableList = articleTopics({ category: id, current: 1 })
			return tableList;
		}

	},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' scoped>
	.antidisease-wrap {
		width: 1280px;
		margin: 0 auto;
		padding: 20px 0;
		.antidisease-box {
			margin-top: 20px;
			& > .left-wrap,
			& > .right-wrap {
				flex-basis: 46%;
				flex-shrink: 0;
				& > ul {
					background-color: #fff;
					& > li {
						border-bottom: 1px dashed hsla(0, 0%, 44%, 0.8);
						padding: 20px 0;
						&:last-child {
							border-bottom: none;
						}
						& > .antidisease--list {
							display: block;
							width: 96%;
							margin: 0 auto;
							text-align: left;

							& > .content {
								color: #999;
								font-size: 14px;
								margin-top: 12px;
							}

							& > .flex {
								& > .title {
									flex-grow: 2;
									color: #333;
									font-size: 16px;
									font-weight: 700;
									padding-right: 15px;
								}
								& > .source {
									color: #999;
									font-size: 14px;
									font-weight: 400;
									flex-basis: 15%;
									text-align: right;
									flex-shrink: 0;
								}
								& > .time {
									color: #999;
									font-size: 14px;
									font-weight: 400;
									flex-shrink: 0;
									padding-left: 4px;
									border-left: 2px solid #999;
									margin-left: 4px;
								}
							}
						}
					}
				}
				& > .flex {
					border-bottom: 1px solid #e1e8ee;
					& > .antidisease-nav {
						font-size: 18px;
						font-weight: 700;
						color: $red;
						vertical-align: baseline;
						padding-bottom: 10px;
						border-bottom: 3px solid $red;
						& > i {
							color: $red;
							font-size: 24px;
							margin-right: 5px;
						}
					}
					& > a {
						font-size: 14px;
						color: #999;
						margin-right: 7px;
					}
				}
			}
		}
	}
</style>